export const STAR_COUNT = 12;
export const STAR_PHASE_MS = 1600;
export const CONFETTI_COUNT = 52;
export const CONFETTI_PHASE_MS = 2400;
export const CELEBRATION_DURATION_MS = STAR_PHASE_MS + CONFETTI_PHASE_MS;
